/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { z } from 'zod';

import { translationKey } from '@change-corgi/core/i18n';

import type { PetitionEditPageData, PetitionEditPageState } from '#src/app/pages/petitionEditV2/pageContext';
import { isMaxByteLength, MAX_SQL_TEXT_BYTE_LENGTH } from '#src/app/shared/utils/validators';

type FormStateDescription = PetitionEditPageState['formState']['description'];

export const descriptionSchema = z
	.string({
		error: (issue) =>
			issue.input === undefined
				? (translationKey('corgi.petition.edit.petition_content.description.required_error') as unknown as string)
				: issue.message, // need translation
	})
	.min(1, {
		message: translationKey('corgi.petition.edit.petition_content.description.required_error') as unknown as string,
	})
	// checking whether the text is shorter than the 'TEXT' byte length in sql
	.refine((val) => isMaxByteLength(val, MAX_SQL_TEXT_BYTE_LENGTH), {
		message: translationKey('corgi.petition.edit.petition_content.description.max_length_error') as unknown as string,
	});

export const deserializeDescription = ({ petition }: Pick<PetitionEditPageData, 'petition'>): FormStateDescription => {
	return {
		value: petition.description,
		error: null,
		dirty: false,
	};
};
